module.exports = __webpack_public_path__ + "static/floor_night_mobile-8fb7c6feeb9be17a16fb810791faa408.jpg";